import React, { forwardRef } from 'react';

/**
 * The search input field.
 *
 * @param {string} value
 * @param onChange
 * @param onBlur
 * @param onKeyDown
 * @param {string} name
 * @param {string} placeholder
 * @param {boolean} loading
 * @param {string} id
 * @param {string} ariaOwns
 * @param {boolean} expanded
 * @param {string} activeDescendant
 * @param ref
 * @return {JSX.Element}
 * @constructor
 */
const SearchInput = forwardRef(({
  value = '',
  onChange,
  onBlur,
  onKeyDown,
  name = 's',
  placeholder = '',
  loading = false,
  id = 'search-field',
  ariaOwns = '',
  expanded = false,
  activeDescendant
}, ref) => {
  return (
    <>
      <input
        ref={ref}
        id={id}
        name={name}
        className="denhaag-search-form__input"
        type="text"
        autoComplete="off"
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        value={value}
        aria-controls={ariaOwns}
        aria-autocomplete='list'
        aria-expanded={expanded}
        aria-activedescendant={activeDescendant}
        role="combobox"
      />
      {
        loading && (
          <svg className="denhaag-search-form__spinner" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" fill="none" stroke="currentColor" strokeWidth="10" r="35" strokeDasharray="164.93361431346415 56.97787143782138">
              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
            </circle>
          </svg>
        )
      }
    </>
  );
});

SearchInput.displayName = 'SearchInput';

export default SearchInput;
